import { Link } from 'docz';
import * as React from 'react';
export default {
  Link,
  React
};